<template>
  <div>
    <Meun ref="menu" :openMenu="openMenu" :width="menuW" @opemMenu="handleOpenMenu"/>
    <div class="hornet-content" :style="{'padding-left':menuW + 24 +'px', 'padding-right': '24px'}">
      <Head @change="handleOpenMenu" :openMenu="openMenu" :width="menuW" @handleOpen="handleOpen"/>
      <NavTab :width="menuW"></NavTab>
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
    <UserModal ref="modal"/>
  </div>
</template>

<script>
import Meun from './menu'
import Head from './head'
import NavTab from './navTab'
import { mapActions } from 'vuex'
import UserModal from './components/userModal'
import './detailPage.scss'
export default {
  components: {
    Meun,
    Head,
    NavTab,
    UserModal,
  },
  data() {
    return {
      openMenu: true
    }
  },
  computed: {
    menuW() {
      return this.openMenu ? 240 : 80
    }
  },
  created() {
    this.getDomianList()
    this.getSecondProductList()
    this.getBrandList()
    this.getCourseList()
  },
  methods: {
    ...mapActions('area', [
      'getDomianList',
      'getSecondProductList',
      'getBrandList',
      'getCourseList',
    ]),
    handleOpen() {
      this.$refs.modal.open()
    },
    handleOpenMenu() {
      this.openMenu = !this.openMenu
    }
  }
}
</script>

<style lang="scss">
.hornet-content {
  transition: all .2s;
  // min-height: 100vh;
  // padding-top: 64px;
  padding-top: 108px;
  position: relative;
  background: #f5f7f9;
}
</style>